import { gozokiApiWithAuth } from '../gozokiApi'
import type { TokenResponse } from '../types/axios.types'

export const askResetPasswordAdminMutation = async ({ email }: { email: string }) => {
  const response = await gozokiApiWithAuth.post('/admin/ask-reset-password', {
    email,
  })
  return response.data
}

export const resetPasswordAdminMutation = async ({
  email,
  code,
  newPassword,
}: {
  email: string
  code: string
  newPassword: string
}) => {
  const response = await gozokiApiWithAuth.post<TokenResponse>('/admin/reset-password', {
    email,
    code,
    newPassword,
  })
  return response.data
}

export const deleteAdmin = async (adminId: number) => {
  const response = await gozokiApiWithAuth.delete(`/admins/${adminId}`)
  return response.data
}
